import React, { useState, useEffect, FC } from 'react'
import { getGoogleCookieUserId } from 'lib/cookies'
import CarouselConnector, {
  ConnectorProps as CarouselProps,
} from '../../../connectors/CarouselABTest'
import FacetConnector, {
  ConnectorProps as FacetProps,
} from 'apps/public/browse/connectors/FacetList'
import Carousel from '../ABTest/Carousel'
import { GOOGLE } from '../../../helpers/constants'
import { getGoogleArtworksPLP, clickArtworkPLPCarousel } from '../helpers'
import { Section } from '../ABTest/styles'
import { getAlgoliaQueryIDFromLocalStorage } from 'lib/algolia/v2/helpers'

const MIN_ARTWORKS = 1
const LIST = 'recently-viewed'

type RecommendedArtworksCarouselProps = CarouselProps &
  FacetProps & {
    shouldLoadComponent: boolean
    setShouldLoadComponent: (...args: Array<any>) => any
  }

const RecommendedArtworksCarousel: FC<RecommendedArtworksCarouselProps> = (props) => {
  const {
    selectedCategoryRecCarousel: category,
    shouldLoadComponent,
    setShouldLoadComponent,
    algoliaSearchIndex,
    algoliaUserToken,
    userID,
  } = props
  const [artworks, handleArtworks] = useState([])
  const relatedSeeMore = {
    link: '#',
    title: `See more ${category}`,
  }
  const algoliaQueryIdFromLocalStorage = getAlgoliaQueryIDFromLocalStorage()

  useEffect(() => {
    if (shouldLoadComponent) {
      const googleUserID = getGoogleCookieUserId()
      getGoogleArtworksPLP({
        callBack: handleArtworks,
        category,
        visitorId: googleUserID,
        pageCategories: category,
      })
    }
  }, [category, shouldLoadComponent])

  if (!artworks || artworks.length < MIN_ARTWORKS) {
    return null
  }

  return (
    <Section data-section={LIST}>
      <h5
        className='defaultTypographyH5'
        data-type='rec-for-you-title'
        style={{ marginBottom: '24px' }}
      >
        Recently Viewed
      </h5>
      <Carousel
        artworks={artworks}
        dataApi={GOOGLE}
        clickArtwork={(ev) => {
          setShouldLoadComponent(false)
          clickArtworkPLPCarousel(ev, algoliaSearchIndex, algoliaUserToken, userID)
        }}
        dataList={LIST}
        dataListId={LIST}
        dataListName='Recently Viewed'
        seeMore={relatedSeeMore}
        hideSeeMore
        algoliaSearchIndex={algoliaSearchIndex}
        algoliaUserToken={algoliaUserToken}
        algoliaQueryID={algoliaQueryIdFromLocalStorage}
        userID={userID}
      />
    </Section>
  )
}

export default CarouselConnector(FacetConnector(RecommendedArtworksCarousel))
